var STATE_DEFAULT = {
  loading: true,
  metadata: null
};
export var FEEDBACK_MENU_LOAD = 'FEEDBACK_MENU_LOAD';
export var FEEDBACK_MENU_UPDATE = 'FEEDBACK_MENU_UPDATE';
export var FEEDBACK_MENU_SUBMIT = 'FEEDBACK_MENU_SUBMIT';
export var FEEDBACK_MENU_SUBMIT_END = 'FEEDBACK_MENU_SUBMIT_END';
export default function feedbackMenu() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FEEDBACK_MENU_LOAD:
      return Object.assign({}, state, {
        loading: true
      });

    case FEEDBACK_MENU_UPDATE:
      return Object.assign({}, state, {
        metadata: action.metadata,
        loading: false
      });

    case FEEDBACK_MENU_SUBMIT:
      return Object.assign({}, state, {
        submitting: true
      });

    case FEEDBACK_MENU_SUBMIT_END:
      return Object.assign({}, state, {
        submitting: false
      });

    default:
      return state;
  }
}